import React, { memo, useCallback } from "react";
import { Box, Theme, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import makeStyles from "@mui/styles/makeStyles";
import { Dialog, Singleselect } from "@shared/components";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { closeDataRoomSetupDialog, hideDataRoomSetupDialog } from "@dataRoomSetup/store/ducks";
import { dataRoomSetupSelector, dataRoomSetupFundSelector } from "@dataRoomSetup/store/selectors";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    [theme.breakpoints.up("sm")]: {
      minWidth: "600px",
    },
  },
}));

const DataRoomSetupFundsDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const funds = useAppSelector(dataRoomSetupFundSelector);
  const { isOpenDataRoomSetupDialog } = useAppSelector(dataRoomSetupSelector);

  const handleDialogClose = useCallback(
    ({ reason }) => {
      if (reason === "closeClick") {
        dispatch(closeDataRoomSetupDialog());
      }
      if (reason === "historyChange") {
        dispatch(hideDataRoomSetupDialog());

        return;
      }
    },
    [dispatch]
  );

  const handleFundChange = useCallback(
    (value) => {
      history.push(value);
    },
    [history]
  );

  return (
    <Dialog
      classes={{
        paperScrollPaper: classes.paper,
      }}
      maxWidth="md"
      title="Data Room Setup"
      onClose={handleDialogClose}
      open={isOpenDataRoomSetupDialog}
      actions={<Typography fontSize={5}>*Select a fund to set up file structures for the data room.</Typography>}
    >
      <Box sx={{ padding: "0 50px" }}>
        <Singleselect
          key={isOpenDataRoomSetupDialog ? "data-room-setup-fund-open" : "data-room-setup-fund-closed"}
          withSearch
          // dropdownWidth={440}
          size="small"
          variant="contained"
          label={"Select Fund"}
          options={funds}
          onSelect={(option) => handleFundChange(option.id)}
        />
      </Box>
    </Dialog>
  );
};

export default memo(DataRoomSetupFundsDialog);
